import { render, staticRenderFns } from "./DashboardOrgAdmin.vue?vue&type=template&id=39232d8d&scoped=true"
import script from "./DashboardOrgAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardOrgAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardOrgAdmin.vue?vue&type=style&index=0&id=39232d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39232d8d",
  null
  
)

export default component.exports